import { AppError } from "config/errors";
import {
  fetchLatestInsuranceApplication,
  fetchLatestInsuranceApplicationDocuments,
} from "gql/queries/insuranceApplications";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getLatestInsuranceApplication = createAsyncThunk(
  "insuranceApplications/fetchLatestInsuranceApplication",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchLatestInsuranceApplication();
      const { latestInsuranceApplication } = getActiveAccount(response.data.me);

      return latestInsuranceApplication;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getLatestInsuranceApplicationDocuments = createAsyncThunk(
  "insuranceApplications/fetchLatestInsuranceApplicationDocuments",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchLatestInsuranceApplicationDocuments();
      const { latestInsuranceApplication } = getActiveAccount(response.data.me);

      return latestInsuranceApplication?.documents;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
